<div class="dialog-content" role="dialog" aria-labelledby="dialogTitle">
  <div class="dialog-header">
    <h2 class="title" id="dialogTitle">Tipps zur Suche</h2>
    <div>
      <button
        data-no-search
        pRipple
        class="close-icon"
        [pAutoFocus]="true"
        aria-label="Dialog schliessen"
        (click)="closeDialog()"
        >
        <img src="assets/icons/close-icon.svg" alt="Dialog schliessen"/>
      </button>
    </div>
  </div>
  <div class="dialog-main-content" [ngClass]="{'no-margin': !config.data.deactivatable}">

    <p-selectButton
      class="search-select help-select"
      [options]="helpTabs"
      [multiple]="false"
      [allowEmpty]="false"
      [ngModel]="helpTabs[selectedHelpTabIndex]"
      (onChange)="updateSelectedHelpTabIndex($event.value)"
      />

      @if (selectedHelpTabIndex === 0) {
        <div class="information-text">
          <div>Sie können für präzise Suchanfragen die folgenden Operatoren nutzen:</div>
        </div>
        <div class="information-item">
          <div class="information-operator-text">
            <h4 class="operator-title">AND</h4>
            <div class="operator-description">
              Sucht nach Einträgen mit beiden Begriffen (=Standardsuche)
            </div>
            <div class="operator-example">z.B. Zermatt <span class="operator">AND</span> Tourismus</div>
          </div>
        </div>
        <div class="information-item">
          <div class="information-operator-text">
            <h4 class="operator-title">OR</h4>
            <div class="operator-description">
              Sucht nach Einträgen mit beiden, sowie dem einem oder anderen Begriff
            </div>
            <div class="operator-example">z.B. Statement <span class="operator">OR</span> Interview</div>
          </div>
        </div>
        <div class="information-item">
          <div class="information-operator-text">
            <h4 class="operator-title">NOT</h4>
            <div class="operator-description">
              Sucht nach Einträgen ohne den genannten Begriff
            </div>
            <div class="operator-example">z.B. Haustier <span class="operator">NOT</span> Katze</div>
          </div>
        </div>
        <div class="information-item">
          <div class="information-operator-text">
            <h4 class="operator-title">NEAR</h4>
            <div class="operator-description">
              Sucht nach zwei Begriffen, die innerhalb einer bestimmten Anzahl Wörter nacheinander vorkommen. Es können einzelne Begriffe, trunkierte Begriffe oder Phrasen angegeben werden
            </div>
            <div class="operator-example">z.B. Abstimmung <span class="operator">NEAR4</span> Nationalrat / Wahl* <span class="operator">NEAR4</span> National* / Geschäft* <span class="operator">NEAR2</span> "zurück an den Nationalrat"</div>
          </div>
        </div>
        <div class="information-item">
          <div class="information-operator-text">
            <h4 class="operator-title">ATLEAST</h4>
            <div class="operator-description">
              Sucht nach Einträgen, die mindestens so oft vorkommen
            </div>
            <div class="operator-example">z.B. <span class="operator">ATLEAST3</span> Wald / <span class="operator">ATLEAST3</span> Baum* / <span class="operator">ATLEAST3</span> "gesunde Bäume"</div>
          </div>
        </div>
        <div class="information-item">
          <div class="information-operator-text">
            <h4 class="operator-title">FIELD</h4>
            <div class="operator-description">
              Sucht Begriff/e nur im Suchfeld, das angegeben wird. Liste der möglichen Suchfelder im <a (click)="openInfo()">Infodokument</a> ersichtlich.
            </div>
            <div class="operator-example">z.B. <span class="operator">Item.ABS:</span>Abstim* OR Wahl</div>
          </div>
        </div>
      }

      @if (selectedHelpTabIndex === 1) {
        <div class="information-text">
          <div>Es gibt drei Suchmöglichkeiten mit unterschiedlicher Ausrichtung:</div>
        </div>
        @for (searchType of searchTypes; track searchType) {
          <div class="information-item">
            <div class="information-image"><img src="{{searchType.image}}"></div>
            <div class="information-search-type-text">
              <h4 class="search-type-title">{{ searchType.title }}</h4>
              <div class="search-type-description">
                {{ searchType.description.main }}
                <ul class="example-list">
                  @for (example of searchType.description.examples; track example) {
                    <li>
                      <div>{{ example.description }}</div>
                      <div class="secondary-text">{{ example.example }}</div>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        }
      }

      @if (config.data.deactivatable) {
        <div class="checkbox-container">
          <!--Aria label required for screen reader-->
          <p-checkbox
            [(ngModel)]="doNotDisplayMessageAgain"
            [binary]="true"
            [attr.aria-label]="'Diese Meldung nicht mehr anzeigen'"
            label=""
            data-no-search
          ></p-checkbox>
          <label class="checkbox-label">Diese Meldung nicht mehr anzeigen</label>
        </div>
      }
    </div>
    @if (config.data.deactivatable) {
      <div class="dialog-footer">
        <button
          data-no-search
          class="search-button"
          type="button"
          pButton
          icon="pi pi-check"
          (click)="accept()"
          label="Ok"
        ></button>
        <button
          data-no-search
          class="dialog-secondary-button"
          type="button"
          pButton
          icon="pi pi-times"
          (click)="closeDialog()"
          label="Abbrechen"
        ></button>
      </div>
    }
  </div>
